let offers;
let theProduct;
let product;
let selectedVariant;

const ADD_BUTTON_WRAPPER_SELECTOR = "div.product-info__add-button";
const ADD_BUTTON_SELECTOR = `${ADD_BUTTON_WRAPPER_SELECTOR} button[type="submit"], ${ADD_BUTTON_WRAPPER_SELECTOR} [name="add"]`;

let mulberrySubmitBypass = false;
let mulberrySubmitInProgress = false;
let lastKnownVariantId = null;
let postSubmitSyncTimer = null;
let cartSyncTimer = null;
let cartSyncInProgress = false;
let pendingCartSync = false;
let cartMulberryRenderTimer = null;
let cartMulberryRenderInProgress = false;
let cartMulberryRetryTimers = [];
let cartDrawerMutationObserver = null;
let cartMulberryLastRenderSignature = "";
let cartMulberryLastRenderAt = 0;

window.__mulberryPdpPairingInProgress = false;
window.__mulberryCartSyncInProgress = false;
window.__mulberryCartInitialized = false;

function getAddToCartButton() {
  return (
    document.querySelector(ADD_BUTTON_SELECTOR) ||
    document.querySelector("product-form [name='add']") ||
    document.querySelector(".js-product-form [name='add']") ||
    document.querySelector('form[action*="/cart/add"] [type="submit"]')
  );
}

function getProductForm() {
  const button = getAddToCartButton();

  return (
    button?.closest("form") ||
    document.querySelector("product-form .js-product-form") ||
    document.querySelector(".js-product-form") ||
    document.querySelector('form[action*="/cart/add"]')
  );
}

function getQuantity() {
  const form = getProductForm();

  const quantityInput =
    form?.querySelector(".quantity__input") ||
    form?.querySelector('input[name="quantity"]') ||
    document.querySelector(".quantity__input") ||
    document.querySelector('input[name="quantity"]');

  const quantity = parseInt(quantityInput?.value || "1", 10);

  return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");

  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  const results = regex.exec(location.search);

  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function getCurrentVariantId() {
  const form = getProductForm();

  const urlVariant = getUrlParameter("variant");
  const formVariant = form?.querySelector('[name="id"]')?.value;
  const globalVariant = window.selectedVariantId || window.mulberryShop?.selectedVariantId;

  return urlVariant || formVariant || globalVariant || "";
}

function getCurrentlySelectedVariant(productData) {
  const variantId = getCurrentVariantId();

  selectedVariant = productData.variants.find(
    function (variant) {
      return `${variant.id}` === `${variantId}`;
    }
  );

  if (!selectedVariant) {
    selectedVariant = productData.variants[0];
  }

  window.mulberryShop.selectedVariantId = selectedVariant.id;
  window.selectedVariant = selectedVariant;
  lastKnownVariantId = `${selectedVariant.id}`;

  return selectedVariant;
}

function ensureMulberryContainer() {
  let container = document.querySelector("#mulberry-container");

  if (container) {
    return container;
  }

  const addButtonWrapper = document.querySelector(ADD_BUTTON_WRAPPER_SELECTOR);

  if (!addButtonWrapper) {
    return null;
  }

  container = document.createElement("div");
  container.id = "mulberry-container";

  addButtonWrapper.parentNode.insertBefore(container, addButtonWrapper);

  return container;
}

function setMulberryLoading(isLoading) {
  const button = getAddToCartButton();

  if (!button) {
    return;
  }

  const spinner =
    button.querySelector(".loading__spinner") ||
    button.querySelector(".spinner") ||
    button.querySelector("[class*='spinner']");

  if (isLoading) {
    button.classList.add("is-loading");
    button.classList.add("loading");
  } else {
    button.classList.remove("is-loading");
    button.classList.remove("loading");
    button.classList.remove("disabled");
    button.removeAttribute("aria-disabled");
  }

  if (spinner) {
    spinner.classList.toggle("hidden", !isLoading);
  }
}

function resetMulberrySubmitState() {
  mulberrySubmitInProgress = false;
  mulberrySubmitBypass = false;
  setMulberryLoading(false);
}

function sleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}

async function getCartJson() {
  const response = await fetch("/cart.js", {
    credentials: "same-origin",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    }
  });

  return response.json();
}

function getLineProperty(item, propertyName) {
  if (!item || !item.properties) {
    return "";
  }

  if (Array.isArray(item.properties)) {
    const property = item.properties.find(function (entry) {
      return entry && entry[0] === propertyName;
    });

    return property ? property[1] : "";
  }

  return item.properties[propertyName] || "";
}

function getMulberryLinkedVariantId(item) {
  return getLineProperty(item, "_variantId");
}

function isMulberryWarrantyItem(item) {
  const linkedVariantId = getMulberryLinkedVariantId(item);

  return !!linkedVariantId && linkedVariantId !== "sectional";
}

function isSectionalMulberryItem(item) {
  return getMulberryLinkedVariantId(item) === "sectional";
}

async function removeCartItemByKey(item) {
  if (!item || !item.key) {
    return null;
  }

  const response = await fetch("/cart/change.js", {
    credentials: "same-origin",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    },
    body: JSON.stringify({
      id: item.key,
      quantity: 0
    })
  });

  if (!response.ok) {
    throw new Error(response.status);
  }

  return response.json();
}

async function removeOrphanMulberryWarrantyItems(cartData) {
  const cart = cartData || await getCartJson();

  if (!cart || !Array.isArray(cart.items)) {
    return false;
  }

  const visibleMainVariantIds = new Set();

  cart.items.forEach(function (item) {
    if (!isMulberryWarrantyItem(item) && !isSectionalMulberryItem(item)) {
      visibleMainVariantIds.add(`${item.variant_id}`);
    }
  });

  const orphanWarrantyItems = cart.items.filter(function (item) {
    const linkedVariantId = getMulberryLinkedVariantId(item);

    return (
      linkedVariantId &&
      linkedVariantId !== "sectional" &&
      !visibleMainVariantIds.has(`${linkedVariantId}`)
    );
  });

  if (!orphanWarrantyItems.length) {
    return false;
  }

  for (const item of orphanWarrantyItems) {
    await removeCartItemByKey(item);
  }

  return true;
}

function syncCartItemsInternalState(cartItems) {
  if (!cartItems) {
    return;
  }

  const quantityInputs = Array.from(cartItems.querySelectorAll('[name="updates[]"]'));

  cartItems.currentTotalItemCount = quantityInputs.reduce(
    function (total, quantityInput) {
      const quantity = parseInt(quantityInput.value || "0", 10);
      return total + (Number.isFinite(quantity) ? quantity : 0);
    },
    0
  );

  cartItems.currentQuantities = [];

  cartItems.querySelectorAll(".cart-item").forEach(function (item) {
    const input = item.querySelector(".qty-input__input") || item.querySelector('[name="updates[]"]');

    if (item.dataset.variantId && input) {
      cartItems.currentQuantities[item.dataset.variantId] = Number(input.value || 0);
    }
  });

  cartItems.dataset.empty = cartItems.querySelector(".cart-item") ? "false" : "true";
}

function hasCartMulberryWidgets() {
  return !!document.querySelector("warranty-details");
}

function getCartMulberrySignature() {
  const wrappers = Array.from(document.querySelectorAll("[data-mulberry-cart-inline]"));

  if (!wrappers.length) {
    return "";
  }

  return wrappers.map(function (wrapper) {
    const cartItem = wrapper.closest(".cart-item");
    const variantId =
      wrapper.dataset.mulberryCartVariantId ||
      wrapper.querySelector("warranty-details")?.dataset.variantId ||
      cartItem?.dataset.variantId ||
      "";

    const quantity =
      cartItem?.querySelector(".qty-input__input")?.value ||
      cartItem?.querySelector('[name="updates[]"]')?.value ||
      "";

    return `${variantId}:${quantity}`;
  }).join("|");
}

function cartMulberryWidgetsAlreadyRendered() {
  const wrappers = Array.from(document.querySelectorAll("[data-mulberry-cart-inline]"));

  if (!wrappers.length) {
    return false;
  }

  return wrappers.every(function (wrapper) {
    return (
      wrapper.querySelector("iframe") ||
      wrapper.querySelector("[class*='mulberry'] iframe") ||
      wrapper.querySelector("[id*='mulberry'] iframe") ||
      !wrapper.querySelector("warranty-details")
    );
  });
}

function clearCartMulberryRenderRetries() {
  cartMulberryRetryTimers.forEach(function (timer) {
    clearTimeout(timer);
  });

  cartMulberryRetryTimers = [];
}

function queueCartMulberryRenderRetries(delays) {
  clearCartMulberryRenderRetries();

  delays.forEach(function (delay) {
    const timer = setTimeout(function () {
      renderCartMulberryWidgets(0, true);
    }, delay);

    cartMulberryRetryTimers.push(timer);
  });
}

function setupCartDrawerMutationObserver() {
  if (cartDrawerMutationObserver || !document.body) {
    return;
  }

  cartDrawerMutationObserver = new MutationObserver(function (mutations) {
    let shouldRender = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (shouldRender || node.nodeType !== 1) {
          return;
        }

        if (
          node.matches?.("warranty-details") ||
          node.querySelector?.("warranty-details") ||
          node.matches?.("cart-items") ||
          node.querySelector?.("cart-items") ||
          node.matches?.("#cart-drawer") ||
          node.querySelector?.("#cart-drawer")
        ) {
          shouldRender = true;
        }
      });
    });

    if (shouldRender) {
      queueCartMulberryRenderRetries([120, 420, 900, 1600]);
    }
  });

  cartDrawerMutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

async function initCartMulberry() {
  if (!window.mulberryShop?.cart) {
    return;
  }

  await renderCartMulberryWidgets(80, true);
}

async function renderCartMulberryWidgets(delay, forceInit) {
  clearTimeout(cartMulberryRenderTimer);

  if (delay) {
    await sleep(delay);
  }

  if (!hasCartMulberryWidgets() || !window.mulberryShop?.cart || typeof window.mulberryShop.cart.render !== "function") {
    return;
  }

  const signature = getCartMulberrySignature();

  if (
    signature &&
    cartMulberryLastRenderSignature === signature &&
    cartMulberryWidgetsAlreadyRendered()
  ) {
    clearCartMulberryRenderRetries();
    return;
  }

  if (
    signature &&
    cartMulberryLastRenderSignature === signature &&
    Date.now() - cartMulberryLastRenderAt < 900
  ) {
    return;
  }

  if (cartMulberryRenderInProgress) {
    scheduleCartMulberryRender(250, true);
    return;
  }

  cartMulberryRenderInProgress = true;

  try {
    if (typeof window.mulberryShop.cart.init === "function" && forceInit !== false) {
      await window.mulberryShop.cart.init();
      window.__mulberryCartInitialized = true;
    }

    cartMulberryLastRenderSignature = signature;
    cartMulberryLastRenderAt = Date.now();

    await window.mulberryShop.cart.render({
      refresh: true
    });

    await sleep(120);

    if (cartMulberryWidgetsAlreadyRendered()) {
      cartMulberryLastRenderSignature = getCartMulberrySignature() || signature;
      cartMulberryLastRenderAt = Date.now();
      clearCartMulberryRenderRetries();
    }

    document.dispatchEvent(new CustomEvent("on:css-var-height:update", { bubbles: true }));
  } catch (error) {
    console.error("Error rendering Mulberry cart widgets:", error);
  } finally {
    cartMulberryRenderInProgress = false;
  }
}

function scheduleCartMulberryRender(delay, forceInit) {
  clearTimeout(cartMulberryRenderTimer);

  cartMulberryRenderTimer = setTimeout(function () {
    renderCartMulberryWidgets(0, forceInit !== false);
  }, delay || 180);
}

async function refreshCartUi() {
  await sleep(80);

  cartMulberryLastRenderSignature = "";

  const cartItems = document.querySelector("cart-items");

  if (cartItems && typeof cartItems.refresh === "function") {
    await cartItems.refresh();
    await sleep(100);
    syncCartItemsInternalState(document.querySelector("cart-items") || cartItems);
    document.dispatchEvent(new CustomEvent("on:css-var-height:update", { bubbles: true }));
    queueCartMulberryRenderRetries([180, 650, 1300, 2400]);
    return;
  }

  const cartDrawer = document.getElementById("cart-drawer") || document.querySelector("cart-drawer");

  if (cartDrawer && typeof cartDrawer.refresh === "function") {
    await cartDrawer.refresh(true);
    document.dispatchEvent(new CustomEvent("on:css-var-height:update", { bubbles: true }));
    queueCartMulberryRenderRetries([180, 650, 1300, 2400]);
    return;
  }

  if (window.location.pathname === "/cart") {
    window.location.reload();
    return;
  }

  queueCartMulberryRenderRetries([180, 650, 1300, 2400]);
}

async function syncWarrantiesAndRefreshCart() {
  if (cartSyncInProgress) {
    pendingCartSync = true;
    return;
  }

  cartSyncInProgress = true;
  window.__mulberryCartSyncInProgress = true;

  try {
    await removeAndSyncWarranties();
    await refreshCartUi();
  } catch (error) {
    console.error("Error during Mulberry cart sync:", error);
  } finally {
    cartSyncInProgress = false;
    window.__mulberryCartSyncInProgress = false;

    if (pendingCartSync) {
      pendingCartSync = false;
      scheduleCartSyncAndRefresh(250);
    }
  }
}

function scheduleCartSyncAndRefresh(delay) {
  clearTimeout(cartSyncTimer);

  cartSyncTimer = setTimeout(function () {
    syncWarrantiesAndRefreshCart();
  }, delay || 450);
}

function schedulePostSubmitSync(delay) {
  clearTimeout(postSubmitSyncTimer);

  postSubmitSyncTimer = setTimeout(async function () {
    try {
      await syncWarrantiesAndRefreshCart();
    } catch (error) {
      console.error("Error during post-submit Mulberry sync:", error);
    } finally {
      window.__mulberryPdpPairingInProgress = false;
      resetMulberrySubmitState();
      queueCartMulberryRenderRetries([250, 800, 1600, 2800]);
    }
  }, delay || 2600);
}

function submitOriginalAddToCart() {
  const button = getAddToCartButton();
  const form = getProductForm();

  mulberrySubmitBypass = true;

  if (button) {
    button.removeAttribute("aria-disabled");
    button.classList.remove("disabled");
    button.classList.remove("loading");
    button.classList.remove("is-loading");
  }

  if (form?.requestSubmit) {
    form.requestSubmit(button || undefined);
  } else if (button) {
    button.click();
  } else if (form) {
    form.dispatchEvent(
      new Event("submit", {
        bubbles: true,
        cancelable: true
      })
    );
  }

  schedulePostSubmitSync();
}

function getWarrantyOfferFromSelection(warranty) {
  return warranty?.offer || warranty;
}

async function addSelectedWarrantyToCart(warranty) {
  const offer = getWarrantyOfferFromSelection(warranty);

  if (!offer || !window.mulberryShop || !window.selectedVariant) {
    return;
  }

  window.__mulberryPdpPairingInProgress = true;

  const result = await window.mulberryShop.getWarrantyVariant(offer);

  await window.mulberryShop.addWarrantyToCart(
    result.shopify_variant_id,
    {
      ...product,
      variantId: `${window.selectedVariant.id}`,
      quantity: getQuantity()
    },
    offer
  );
}

async function continueWithWarranty(warranty) {
  if (mulberrySubmitInProgress) {
    return;
  }

  mulberrySubmitInProgress = true;
  setMulberryLoading(true);

  try {
    await addSelectedWarrantyToCart(warranty);

    window.selectedWarranty = null;
    window.productForWarranty = null;

    if (window.pdpInline?.deselectOffer) {
      window.pdpInline.deselectOffer();
    }

    if (window.mulberry?.inline?.deselectOffer) {
      window.mulberry.inline.deselectOffer();
    }

    submitOriginalAddToCart();
  } catch (error) {
    console.error("Error adding Mulberry warranty:", error);
    window.__mulberryPdpPairingInProgress = false;
    resetMulberrySubmitState();
  }
}

async function getOffers() {
  const productData = await window.mulberryShop.getProductData(
    window.mulberryShop.getProductUrl()
  );

  product = productData.product;
  theProduct = productData.product;

  selectedVariant = getCurrentlySelectedVariant(product);

  if (
    selectedVariant &&
    selectedVariant.id &&
    selectedVariant.price
  ) {
    return window.mulberry.core.getWarrantyOffer({
      detail: {
        ...product,
        id: selectedVariant.id
      },
      title: product.title,
      id: selectedVariant.id,
      price: selectedVariant.price
    });
  }

  return [];
}

async function refreshOffersForCurrentVariant(force = false) {
  if (!theProduct || !window.mulberryShop || !window.mulberry?.core) {
    return;
  }

  const currentVariantId = getCurrentVariantId();

  if (!force && currentVariantId && `${currentVariantId}` === `${lastKnownVariantId}`) {
    return;
  }

  selectedVariant = theProduct.variants.find(
    function (variant) {
      return `${variant.id}` === `${currentVariantId}`;
    }
  );

  if (!selectedVariant) {
    selectedVariant = theProduct.variants[0];
  }

  window.mulberryShop.selectedVariantId = selectedVariant.id;
  window.selectedVariant = selectedVariant;
  lastKnownVariantId = `${selectedVariant.id}`;

  window.selectedOffer = null;
  window.selectedWarranty = null;
  window.productForWarranty = null;

  if (window.pdpInline?.deselectOffer) {
    window.pdpInline.deselectOffer();
  }

  offers = await window.mulberry.core.getWarrantyOffer({
    id: selectedVariant.id,
    title: theProduct.title,
    price: selectedVariant.price,
    detail: theProduct
  });

  window.offers = offers || [];

  const container = ensureMulberryContainer();

  if (offers && offers.length) {
    if (container) {
      container.style.display = "block";
    }

    if (window.mulberry.core.settings.has_inline && window.pdpInline?.updateOffer) {
      window.pdpInline.updateOffer(offers);
    }

    if (window.mulberry.core.settings.has_modal && window.mulberryPDPModal?.updateOffer) {
      window.mulberryPDPModal.updateOffer(offers);
    } else if (window.mulberry.core.settings.has_modal && window.mulberry?.modal?.updateOffer) {
      window.mulberry.modal.updateOffer(offers);
    }
  } else {
    if (container) {
      container.style.display = "none";
    }

    if (window.mulberry.core.settings.has_modal && window.mulberryPDPModal?.updateOffer) {
      window.mulberryPDPModal.updateOffer([]);
    } else if (window.mulberry.core.settings.has_modal && window.mulberry?.modal?.updateOffer) {
      window.mulberry.modal.updateOffer([]);
    }
  }
}

async function initMulberry() {
  ensureMulberryContainer();

  window.offers = await getOffers();
  offers = window.offers || [];

  const container = ensureMulberryContainer();

  if (!offers.length && container) {
    container.style.display = "none";
  }

  if (window.mulberry.core.settings.has_inline) {
    window.pdpInline = await window.mulberry.inline.init({
      offers: offers,
      settings: window.mulberry.core.settings,
      selector: "#mulberry-container",
      onWarrantyToggle: async function (warranty) {
        if (warranty.isSelected) {
          window.selectedWarranty = warranty;
          window.productForWarranty = product;
        } else {
          window.selectedWarranty = null;
          window.productForWarranty = null;
        }
      }
    });
  }

  if (window.mulberry.core.settings.has_modal) {
    window.mulberryPDPModal = window.mulberry.modal.init({
      offers: offers,
      settings: window.mulberry.core.settings,
      onWarrantySelect: async function (warranty) {
        window.productForWarranty = product;

        await continueWithWarranty(warranty);

        if (window.mulberry?.modal?.close) {
          window.mulberry.modal.close();
        }
      },
      onWarrantyDecline: function () {
        window.__mulberryPdpPairingInProgress = false;

        if (window.mulberry?.modal?.close) {
          window.mulberry.modal.close();
        }

        submitOriginalAddToCart();
      }
    });
  }

  setupAddToCartInterception();
  setupVariantChangeListeners();

  await refreshOffersForCurrentVariant(true);
}

function setupAddToCartInterception() {
  const button = getAddToCartButton();
  const form = getProductForm();

  if (button && !button.dataset.mulberryBound) {
    button.dataset.mulberryBound = "true";

    button.addEventListener(
      "click",
      async function (e) {
        if (mulberrySubmitBypass || mulberrySubmitInProgress) {
          return;
        }

        const currentOffers = window.offers || offers || [];

        if (!currentOffers.length) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (window.selectedWarranty) {
          await continueWithWarranty(window.selectedWarranty);
          return;
        }

        if (window.mulberry.core.settings.has_modal && window.mulberry?.modal?.open) {
          setMulberryLoading(true);
          window.mulberry.modal.open();
          return;
        }

        submitOriginalAddToCart();
      },
      true
    );
  }

  if (form && !form.dataset.mulberryBound) {
    form.dataset.mulberryBound = "true";

    form.addEventListener(
      "submit",
      async function (e) {
        if (mulberrySubmitBypass || mulberrySubmitInProgress) {
          return;
        }

        const currentOffers = window.offers || offers || [];

        if (!currentOffers.length) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (window.selectedWarranty) {
          await continueWithWarranty(window.selectedWarranty);
          return;
        }

        if (window.mulberry.core.settings.has_modal && window.mulberry?.modal?.open) {
          setMulberryLoading(true);
          window.mulberry.modal.open();
          return;
        }

        submitOriginalAddToCart();
      },
      true
    );
  }
}

function setupVariantChangeListeners() {
  let lastUrl = location.href;

  const handleChange = function () {
    setTimeout(function () {
      refreshOffersForCurrentVariant();
    }, 80);
  };

  document.addEventListener("change", function (e) {
    if (
      e.target.matches('[name="id"]') ||
      e.target.matches('select[name="id"]') ||
      e.target.matches('input[type="radio"]') ||
      e.target.closest("variant-selects") ||
      e.target.closest("variant-radios")
    ) {
      handleChange();
    }
  });

  document.addEventListener("click", function (e) {
    if (
      e.target.closest("variant-selects") ||
      e.target.closest("variant-radios") ||
      e.target.closest("[data-option-value]") ||
      e.target.closest("[data-variant-id]")
    ) {
      handleChange();
    }
  });

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function () {
    originalPushState.apply(this, arguments);
    window.dispatchEvent(new Event("mulberry-locationchange"));
  };

  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    window.dispatchEvent(new Event("mulberry-locationchange"));
  };

  window.addEventListener("popstate", function () {
    window.dispatchEvent(new Event("mulberry-locationchange"));
  });

  window.addEventListener("mulberry-locationchange", function () {
    handleChange();
  });

  const observer = new MutationObserver(function () {
    if (lastUrl !== location.href) {
      lastUrl = location.href;
      handleChange();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

async function removeAndSyncWarranties() {
  const firstCart = await getCartJson();

  firstCart.items = firstCart.items.filter(
    function (item) {
      return !isSectionalMulberryItem(item);
    }
  );

  try {
    const newCart = await window.mulberryShop.removeDetachedWarranty(firstCart);
    await window.mulberryShop.cart.syncQuantities(newCart);
  } catch (error) {
    console.error("Error during warranty removal and cart sync:", error);
  }

  try {
    await removeOrphanMulberryWarrantyItems();
  } catch (error) {
    console.error("Error during orphan Mulberry warranty cleanup:", error);
  }
}

function setupCartSyncListeners() {
  if (window.__mulberryCartSyncListenersBound) {
    return;
  }

  window.__mulberryCartSyncListenersBound = true;

  document.addEventListener("click", function (e) {
    if (e.target.closest(".js-remove-item")) {
      cartMulberryLastRenderSignature = "";
      clearCartMulberryRenderRetries();
      scheduleCartSyncAndRefresh(900);
    }
  });

  document.addEventListener("on:line-item:change", function () {
    if (window.__mulberryCartSyncInProgress || window.__mulberryPdpPairingInProgress) {
      return;
    }

    cartMulberryLastRenderSignature = "";
    scheduleCartSyncAndRefresh(500);
  });

  document.addEventListener("on:cart:add", function () {
    cartMulberryLastRenderSignature = "";

    if (window.__mulberryPdpPairingInProgress) {
      schedulePostSubmitSync(1500);
      return;
    }

    scheduleCartSyncAndRefresh(900);
  });

  document.addEventListener("on:cart:error", function () {
    window.__mulberryPdpPairingInProgress = false;
    resetMulberrySubmitState();
  });

  document.addEventListener("on:cart-drawer:before-open", function () {
    scheduleCartMulberryRender(250, true);
  });

  document.addEventListener("on:cart-drawer:after-open", function () {
    queueCartMulberryRenderRetries([120, 650, 1400]);
  });

  document.addEventListener("on:cart:before-open", function () {
    scheduleCartMulberryRender(250, true);
  });

  document.addEventListener("on:cart:after-open", function () {
    queueCartMulberryRenderRetries([120, 650, 1400]);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  setupCartSyncListeners();
  setupCartDrawerMutationObserver();

  document.addEventListener("mulberry-shopify:loaded", async function () {
    window.mb_gtm_is_disabled = true;

    await removeAndSyncWarranties();
    await initCartMulberry();

    if (document.location.href.includes("/products/")) {
      await initMulberry();
    }
  });
});

document.addEventListener("mulberry-shopify:warranty-added", async function () {
  if (
    window.__mulberryPdpPairingInProgress &&
    document.location.href.includes("/products/")
  ) {
    schedulePostSubmitSync(1600);
    return;
  }

  scheduleCartSyncAndRefresh(500);
});